import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import SubscribeBell from '@lt/components/icons-react/rebrand/Notification';

import {
  FloatingPanelButton,
  ButtonContainer,
  BottomButtonText,
} from '../styles';
import {
  ACTIVE_SUBSCRIBE_BELL_DATA_TEST_ID,
  SUBSCRIBE_BELL_DATA_TEST_ID,
  SUBSCRIBE_BUTTON_DATA_TEST_ID,
} from './constants';

interface ISubscribeButton {
  isSubscribed: boolean;
  toggleSubscribe: () => void;
}

const SubscribeButton = ({
  isSubscribed,
  toggleSubscribe,
}: ISubscribeButton) => {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      onClick={toggleSubscribe}
      data-testid={SUBSCRIBE_BUTTON_DATA_TEST_ID}
    >
      <ButtonContainer>
        {isSubscribed ? (
          <StyledActiveSubscribeBell
            data-testid={ACTIVE_SUBSCRIBE_BELL_DATA_TEST_ID}
          />
        ) : (
          <StyledSubscribeBell data-testid={SUBSCRIBE_BELL_DATA_TEST_ID} />
        )}
        <BottomButtonText>{t('subscribe.button')}</BottomButtonText>
      </ButtonContainer>
    </Button>
  );
};

const Button = styled(FloatingPanelButton)`
  border-top-left-radius: var(--border-radius);
  border-bottom-left-radius: var(--border-radius);
`;

const StyledSubscribeBell = styled(SubscribeBell)`
  height: 16px;
`;

// Одинаковые иконки с StyledSubscribeBell пока не запилят новую
const StyledActiveSubscribeBell = styled(SubscribeBell)`
  height: 16px;
`;

export default SubscribeButton;
